/* unplugin-vue-components disabled */import { render } from "./MoblieUpload.vue?vue&type=template&id=1a480244"
import script from "./MoblieUpload.vue?vue&type=script&lang=js"
export * from "./MoblieUpload.vue?vue&type=script&lang=js"

import exportComponent from "/home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__